import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`
const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
  border: 1px #e7e7e7 solid;
  margin-top: 10px
`
const Title = styled.h2`

`

const Subtitle = styled.p`
  margin-bottom: 0px;
`
export {
  Container,
  CardContainer,
  Title,
  Subtitle
}
